var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1745 9.91564C13.6433 10.2706 13.0188 10.46 12.38 10.46C11.5233 10.46 10.7018 10.1197 10.096 9.51394C9.4903 8.9082 9.14999 8.08665 9.14999 7.23C9.14999 6.59117 9.33943 5.96668 9.69435 5.43551C10.0493 4.90434 10.5537 4.49034 11.1439 4.24587C11.7341 4.0014 12.3836 3.93743 13.0101 4.06206C13.6367 4.18669 14.2122 4.49431 14.664 4.94604C15.1157 5.39776 15.4233 5.97329 15.5479 6.59985C15.6726 7.2264 15.6086 7.87585 15.3641 8.46606C15.1196 9.05626 14.7057 9.56072 14.1745 9.91564Z",
    stroke: "#111827",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.43C6 14.72 8.61999 12.83 12.38 12.83C16.14 12.83 18.76 14.72 18.76 17.43C18.7595 17.5469 18.7288 17.6617 18.671 17.7633C18.6132 17.8649 18.5302 17.9498 18.43 18.01C18.35 18.05 16.5 19.12 12.21 19.12C8.06999 19.12 6.45999 18.1 6.28999 17.99C6.20121 17.9258 6.12872 17.8418 6.07835 17.7445C6.02799 17.6472 6.00116 17.5395 6 17.43Z",
    stroke: "#111827",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyMenu);
export default __webpack_public_path__ + "static/media/icon-my-menu.f25f6797980451ae643d51f0f2ec6a7a.svg";
export { ForwardRef as ReactComponent };